import TIK from 'constants/time/timeIntervalKind.const';
import { firstOf, secondOf } from 'utils/arrays/elements.util';
import { fromAnyDateToIso, fromAnyDateToTimestamp, fromAnyDateToZulu } from 'utils/converters/time/from.util';
import createTimeInterval from 'utils/predicates/time/createTimeInterval.util';

const parseDateOrRange = (ev) => {
  const isRange = Array.isArray(ev);

  if (!isRange) {
    return {
      raw: ev,
      iso: fromAnyDateToIso(ev),
      zulu: fromAnyDateToZulu(ev),
      timestamp: fromAnyDateToTimestamp(ev),
    };
  }

  const custom = { bgn: firstOf(ev), end: secondOf(ev) };
  const interval = createTimeInterval({ kind: TIK.custom, custom });

  const result = { ...interval, raw: ev };
  delete result.kind;

  return result;
};

export default parseDateOrRange;
